<template>
  <div>
    <div class="content">
      {{created_on}}
    </div>

    <div class="subtext">
    CREATED ON
    </div>

    <div class="content">
      <AccountLink v-bind:account="created_by" id="created_by" link_style="color: white"/>
    </div>

    <div class="subtext">
    CREATED BY
    </div>

    <div class="content">
      <div v-for="flag in flags" v-bind:key="flag">
        {{flag}} <!-- TODO: icon_for(flag) -->
      </div>
    </div>

    <div class="subtext">
    FLAGS
    </div>

    <div class="content" v-if="!!advisory_level">
      <span      v-if="advisory_level == 3">Warning: Fraudulent Account</span>
      <span v-else-if="advisory_level == 2">Warning: High Likelihood of Fraudulent Activity</span>
      <span v-else-if="advisory_level == 1">Warning: Possible Fraudulent Activity</span>
    </div>
  </div>
</template>

<script>
import AccountLink from '../AccountLink'
import config from '../../config'
import tags from '../../tags'

export default {
  name: 'AccountDetailsMeta',

  components : {
    AccountLink
  },

  props : {
         id : String,
       info : Object,
    info_v2 : Object
  },

  computed : {
    created_on : function(){
      return (this.info_v2["inception"] || "").replace("T", " ").replace("Z", "");
    },

    created_by : function(){
      return this.info_v2["parent"] || "";
    },

    flags : function(){
      return Object.keys(config.ACCOUNT_ROOT_FLAGS)
                   .filter(function(flag){
                     return this.info["Flags"] & config.ACCOUNT_ROOT_FLAGS[flag];
                   }.bind(this));
    },

    advisory_level : function(){
      return tags.advisory_level(this.id)
    }
  }
}
</script>

<style scoped>
#created_by a{
  color: white;
}
</style>
